























































































import { Component, Prop, Vue } from "vue-property-decorator";
import pdf from "vue-pdf";

@Component({
  components: {
    pdf,
  },
})
export default class Pdf extends Vue {
  @Prop() item;
  @Prop() zoom;
  show = true;
  page = 1;
  numPages = 0;
  nextPage() {
    if (this.page + 1 <= this.numPages) this.page += 1;
  }
  formerPage() {
    if (this.page - 1 >= 1) this.page -= 1;
  }
  openDialog(v) {
    this.zoom = true;
    this.$emit("showDialog", v);
  }
  cetak(v) {
    window.open(v, "_blank");
  }
}
